export default __webpack_public_path__ + "static/media/dermatology.aea1afa1.svg";